export class AuditLogFilterConditions {
    'action';
    'operationName';
    'initiatorId';
    'statusCode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "action",
            "baseName": "action",
            "type": "ActionFilters",
            "format": ""
        },
        {
            "name": "operationName",
            "baseName": "operationName",
            "type": "OperationIdFilters",
            "format": ""
        },
        {
            "name": "initiatorId",
            "baseName": "initiatorId",
            "type": "UserIdFilters",
            "format": ""
        },
        {
            "name": "statusCode",
            "baseName": "statusCode",
            "type": "StatusCodeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
